import * as types from '../actions/ActionTypes';
import initialState from './InitialState';

export default function invoiceJournalsReducer(
    state: any = initialState,
    action: { type: string; result: any }
) {
    switch (action.type) {
        case types.GET_INVOICE_JOURNAL_LIST:
            return {
                ...state,
                legalEntities: action.result.legalEntities
            };

        case types.GET_INVOICE_JOURNAL:
            return {
                ...state,
                invoiceJournal: action.result.invoiceJournal
            };

        case types.CREATE_INVOICE_JOURNAL:
            return {
                ...state,
                legalEntities: state.legalEntities.map((entity: any) => {
                    if (
                        entity.id === action.result.legalEntityId &&
                        entity.site === action.result.site
                    ) {
                        return {
                            ...entity,
                            numberOfNewInvoices:
                                action.result.numberOfNewInvoices !== null
                                    ? action.result.numberOfNewInvoices
                                    : entity.numberOfNewInvoices,
                            numberOfNewForeignInvoices:
                                action.result.numberOfNewForeignInvoices !== null
                                    ? action.result.numberOfNewForeignInvoices
                                    : entity.numberOfNewForeignInvoices,
                            localInvoiceJournals:
                                action.result.localInvoiceJournal !== null
                                    ? [
                                          action.result.localInvoiceJournal,
                                          ...entity.localInvoiceJournals
                                      ]
                                    : [...entity.localInvoiceJournals],
                            foreignInvoiceJournals:
                                action.result.foreignInvoiceJournal !== null
                                    ? [
                                          action.result.foreignInvoiceJournal,
                                          ...entity.foreignInvoiceJournals
                                      ]
                                    : [...entity.foreignInvoiceJournals]
                        };
                    } else {
                        return entity;
                    }
                })
            };

        default:
            return state;
    }
}
